import moment from 'moment-timezone'

export const stringToKebabCase = (str: string) => {
  return (
    str
      ?.match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
      )
      ?.map((x) => x.toLowerCase())
      .join('-') || ''
  )
}

export const kebabToTitleCase = (str: string) => {
  return str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const copyToClipboard = (text: string): void => {
  if (!navigator.clipboard) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed' // Prevent scrolling to the textarea
    textArea.style.opacity = '0' // Make it invisible
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
    } catch (err) {
      console.error('Failed to copy text:', err)
    } finally {
      document.body.removeChild(textArea)
    }
    return
  }

  // Clipboard API for modern browsers
  navigator.clipboard
    .writeText(text)
    .then(() => {
      console.log('Text copied to clipboard.')
    })
    .catch((err) => {
      console.error('Failed to copy text:', err)
    })
}

export const hexToRgb = (color: string): string => {
  var h = '0123456789ABCDEF'
  var r = h.indexOf(color[1]) * 16 + h.indexOf(color[2])
  var g = h.indexOf(color[3]) * 16 + h.indexOf(color[4])
  var b = h.indexOf(color[5]) * 16 + h.indexOf(color[6])

  return r + ', ' + g + ', ' + b
}

export const generateISO = (): string => {
  const date = moment().tz('Europe/Istanbul').format()

  return date
}

function hashString(str: string): string {
  let hash = 0
  if (str.length === 0) return hash.toString()
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash).toString()
}

export const getVisitorId = (): string => {
  const fingerprintData = [
    navigator.userAgent,
    screen.width,
    screen.height,
    screen.colorDepth,
    navigator.language,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.platform,
    navigator.hardwareConcurrency,
    navigator.mediaDevices,
  ].join('|')

  return hashString(fingerprintData)
}

export const getDomainFromURL = (url: string) => {
  if (!url) return ''
  let result = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')?.split('/')[0]
  return result
}

export const mapTiming = () => {
  if (typeof window === 'undefined' || !window.performance) return {}

  const timing =
    (window.performance.getEntriesByType(
      'navigation',
    )[0] as PerformanceNavigationTiming) ||
    (window.performance.timing as PerformanceTiming)

  if (!timing) return {}

  return {
    ConnectStart: timing.connectStart,
    NavigationStart:
      'navigationStart' in timing ? timing.navigationStart : timing.workerStart,
    LoadEventEnd: timing.loadEventEnd,
    DomLoading: 'domLoading' in timing ? timing.domLoading : timing.duration,
    SecureConnectionStart: timing.secureConnectionStart,
    FetchStart: timing.fetchStart,
    DomContentLoadedEventStart: timing.domContentLoadedEventStart,
    ResponseStart: timing.responseStart,
    ResponseEnd: timing.responseEnd,
    DomInteractive: timing.domInteractive,
    DomainLookupEnd: timing.domainLookupEnd,
    RedirectStart: timing.redirectStart,
    RequestStart: timing.requestStart,
    UnloadEventEnd: timing.unloadEventEnd,
    UnloadEventStart: timing.unloadEventStart,
    DomComplete: timing.domComplete,
    DomainLookupStart: timing.domainLookupStart,
    LoadEventStart: timing.loadEventStart,
    DomContentLoadedEventEnd: timing.domContentLoadedEventEnd,
    RedirectEnd: timing.redirectEnd,
    ConnectEnd: timing.connectEnd,
  }
}
